import React, { Component } from 'react';
import { Tab, Tabs } from 'material-ui/Tabs';
import FontIcon from 'material-ui/FontIcon';
import { connect } from 'react-redux';

import GlobalVariables, { base64Decode } from '../../../../actions/utilAction';
import { SetUUID, resetProgramAndTarget } from './componnets/SkillAquisition/components/programs/actions/programsActions';
import { isRecordDurationRenderTrue } from './componnets/BehaviorData/actions/BehaviourDataActions';
import { isRecordDurationRenderTrueSkAq } from './componnets/SkillAquisition/components/targets/actions/targetsActionNewFlow';
import PatientInfo from '../../patient_info';
import SkillAcqActivePrograms from './componnets/SkillAquisition/components/programs/program';
import Notes from './componnets/Notes/index';
import BehaviourData from './componnets/BehaviorData/index';
import MaintenanceActivePrograms from './componnets/Maintenance/components/programs/program';
import uuid from "uuid";
import { getMasterData } from '../DataCollection/SkillAquisition/components/Target/actions/skillAquisitionTargetActions';
import BeepComponent from './componnets/BehaviorData/components/RecordInterval/BeepComponent';

class CollectData extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            activeTabValue: '0',
            patientId: this.props.match.params.id ? base64Decode(this.props.match.params.id) : 0,
        }

    }

    setActive = (value) => {
        this.setState({ activeTab: value, activeTabValue: value });
    }

    componentWillMount =  () => {
        let masterData = { 'masterdata': 'MASTERDOMAINSWITHLIBRARY,MASTERPROGRAMS,MASTERDESIREDDAILYTRIALS,MASTERAUTOOPENORDER,MASTERTARGETTYPE,MASTERRESPONSEPERCENTAGE,MASTERCONSECUTIVEDAYS,MASTERFIRSTTRIALMUSTBEINDEPENDENT,MASTERYTYPE,TARGETSTATUS,TARGETSTATUSWITHOUTREADY,DCMASTERMAINTENANCELEVELS,MASTERSTAFFACTIVEANDINACTIVE' };
        this.props.getMasterData(masterData);
        let generateduuid = uuid.v4()
        this.props.resetProgramAndTarget()
        this.props.SetUUID(generateduuid)
        this.props.isRecordDurationRenderTrue(true);
        this.props.isRecordDurationRenderTrueSkAq(true);
    }

    renderSkillAquisitionTabs = () => {

    }

    renderBehaviorDataTabs = () => {

    }

    render() {

        let customTimeForInterval = this.props.customTimeForInterval;
        customTimeForInterval = customTimeForInterval * 60 * this.props.intervalCount;

        var styles = {
            default_tab: {
                height: '50px',
                fontSize: '13px',
            },
            active_tab: {
                color: '#fff',
                backgroundColor: 'rgba(0, 0, 0, 0.10)',
                height: '48px',
                fontSize: '13px',
            },
        };
        styles.tab = [];
        styles.tab[0] = styles.default_tab;
        styles.tab[1] = styles.default_tab;
        styles.tab[2] = styles.default_tab;
        styles.tab[3] = styles.default_tab;
        styles.tab[4] = styles.default_tab;
        styles.tab[5] = styles.default_tab;
        styles.tab[this.state.activeTab] = styles.active_tab;
        styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
        return (
            <div>
                {this.props.displayTodaysData ? 
                    <h2 className="page_title">Collect Data Setup {' > '} Today's Data</h2>
                    :
                    <h2 className="page_title">Collect Data Setup</h2>
                }
                <PatientInfo patientId={this.state.patientId} />
                <div className="clearfix"></div>
                <div className="readmin-panel">
                    <div className="panel-body">
                        <Tabs className="custom_tabs" value={this.state.activeTabValue} >
                            <Tab
                                onClick={(e) => this.setActive('0')}
                                style={styles.tab[0]}
                                value="0"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Skill Acquisition</font>}>
                                {
                                    this.state.activeTabValue === '0' ?
                                        <SkillAcqActivePrograms patientId={this.state.patientId} 
                                        addPermissionSkillAquisition = {this.props.addPermissionSkillAquisition}
                                        updatePermissionSkillAquisition = {this.props.updatePermissionSkillAquisition}
                                        deletePermissionSkillAquisition =  {this.props.deletePermissionSkillAquisition}
                                        />
                                        : ''
                                }
                            </Tab>

                            <Tab
                                onClick={(e) => this.setActive('1')}
                                style={styles.tab[1]}
                                value="1"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Behavior Data</font>}>
                                {
                                    this.state.activeTabValue === '1' ?
                                        <BehaviourData patientId={this.state.patientId}
                                        addPermissionBehavior = {this.props.addPermissionBehavior}
                                        updatePermissionBehavior = {this.props.updatePermissionBehavior}
                                        deletePermissionBehavior =  {this.props.deletePermissionBehavior} />
                                        : ''
                                }
                            </Tab>
                            <Tab
                                onClick={(e) => this.setActive('2')}
                                style={styles.tab[2]}
                                value="2"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Clipboard</font>}>
                                {
                                    this.state.activeTabValue === '2' ?
                                        <Notes patientId={this.state.patientId}
                                        addPermissionNotes = {this.props.addPermissionNotes}
                                        updatePermissionNotes = {this.props.updatePermissionNotes}
                                        deletePermissionNotes =  {this.props.deletePermissionNotes} />
                                        : ''
                                }
                            </Tab>
                            <Tab
                                onClick={(e) => this.setActive('3')}
                                style={styles.tab[3]}
                                value="3"
                                className="customtab"
                                icon={<FontIcon className="material-icons">local_library</FontIcon>}
                                label={<font>Maintenance</font>}>
                                {
                                    this.state.activeTabValue === '3' ?
                                        <MaintenanceActivePrograms patientId={this.state.patientId} 
                                        addPermissionSkillAquisition = {this.props.addPermissionSkillAquisition}
                                        updatePermissionSkillAquisition = {this.props.updatePermissionSkillAquisition}
                                        deletePermissionSkillAquisition =  {this.props.deletePermissionSkillAquisition}
                                        />
                                        : ''
                                }
                            </Tab>
                        </Tabs>
                        <BeepComponent condition={(this.props.secondsElapsed == (Math.floor(customTimeForInterval) - 5)) && this.props.beepFlag} />
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state){

    // Start For Role Permission
    let userActionPermission = [];
    if (state.login.userPermission) {
        let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === "CLIENT");
        let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === "CLIENT_DATACOLLECTION" && obj.moduleId === userModulePermission[0].moduleId);
        userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

    let addPermissionSkillAquisition = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADD_SKILL_AQUISITION_TRIALS")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADD_SKILL_AQUISITION_TRIALS")[0].permission : false;
    let updatePermissionSkillAquisition = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_SKILL_AQUISITION_TRIALS")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_SKILL_AQUISITION_TRIALS")[0].permission : false;
    let deletePermissionSkillAquisition = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_SKILL_AQUISITION_TRIALS")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_SKILL_AQUISITION_TRIALS")[0].permission : false;

    let addPermissionBehavior = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADD_BEHAVIOR_DATA")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADD_BEHAVIOR_DATA")[0].permission : false;
    let updatePermissionBehavior = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_BEHAVIOR_DATA")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_BEHAVIOR_DATA")[0].permission : false;
    let deletePermissionBehavior = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_BEHAVIOR_DATA")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_BEHAVIOR_DATA")[0].permission : false;

    let addPermissionNotes = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADD_NOTES")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADD_NOTES")[0].permission : false;
    let updatePermissionNotes = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_NOTES")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_UPDATE_NOTES")[0].permission : false;
    let deletePermissionNotes = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_NOTES")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_NOTES")[0].permission : false;

    // let addPermissionViewSummary = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_VIEW_SUMMARY_DATA")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_VIEW_SUMMARY_DATA")[0].permission : false;
    // let updatePermissionAddEditSummary = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADDEDIT_SUMMARY_DATA")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_ADDEDIT_SUMMARY_DATA")[0].permission : false;
    // let deletePermissionDeleteSummary = hasDefaultAccess ? true : userActionPermission && userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_SUMMARY_DATA")[0] ? userActionPermission.filter((obj) => obj.actionKey === "CLIENT_DATACOLLECTION_DELETE_SUMMARY_DATA")[0].permission : false;

    // End For Role Permission

    return {
        secondsElapsed: state.patientRecordIntervalCustomReducer.secondsElapsed,
        intervalCount: state.patientRecordIntervalCustomReducer.intervalCount,
        customTimeForInterval: state.patientRecordIntervalCustomReducer.recordIntervalCustomTime !== null && state.patientRecordIntervalCustomReducer.recordIntervalCustomTime.data ? state.patientRecordIntervalCustomReducer.recordIntervalCustomTime.data.partialIntervalDuration : GlobalVariables.IntervalDuration,
        beepFlag: state.patientRecordIntervalCustomReducer.beepFlag,
        displayTodaysData: state.patientSkillAcqActiveTarget ? state.patientSkillAcqActiveTarget.displayTodaysData : false,
        addPermissionSkillAquisition: addPermissionSkillAquisition,
        updatePermissionSkillAquisition: updatePermissionSkillAquisition,
        deletePermissionSkillAquisition: deletePermissionSkillAquisition,
        addPermissionBehavior: addPermissionBehavior,
        updatePermissionBehavior: updatePermissionBehavior,
        deletePermissionBehavior: deletePermissionBehavior,
        addPermissionNotes: addPermissionNotes,
        updatePermissionNotes: updatePermissionNotes,
        deletePermissionNotes: deletePermissionNotes,
    }
}


export default connect(mapStateToProps, {SetUUID, resetProgramAndTarget, isRecordDurationRenderTrue, isRecordDurationRenderTrueSkAq,getMasterData})(CollectData)



// WEBPACK FOOTER //
// ./src/modules/patients/components/collectData/index.js